import axiosInstance from './axiosInstance';
import { IBadge } from '../types/damTypes';

export interface BadgeCreateData {
  name: string;
  color: string;
  textColor: string;
  displayOrder?: number;
  visibleInAll?: boolean;
  visibleInCategories?: string[];
  displayEmoji?: string;
  showName?: boolean;
  iconUrl?: string;
}

export interface BadgeUpdateData {
  name?: string;
  color?: string;
  textColor?: string;
  displayOrder?: number;
  isActive?: boolean;
  visibleInAll?: boolean;
  visibleInCategories?: string[];
  displayEmoji?: string;
  showName?: boolean;
  iconUrl?: string;
}

export interface BadgeReorderData {
  badgeIds: string[];
}

// Get all active badges
export const getBadges = async (options?: { categoryId?: string; includeAll?: boolean }): Promise<IBadge[]> => {
  const params: any = {};
  if (options?.categoryId) params.category = options.categoryId;
  if (options?.includeAll) params.includeAll = 'true';
  const response = await axiosInstance.get('/api/badges', { params });
  return response.data;
};

// Get a specific badge by ID
export const getBadge = async (id: string): Promise<IBadge> => {
  const response = await axiosInstance.get(`/api/badges/${id}`);
  return response.data;
};

// Create a new badge
export const createBadge = async (badgeData: BadgeCreateData): Promise<IBadge> => {
  const response = await axiosInstance.post('/api/badges', badgeData);
  return response.data;
};

// Update a badge
export const updateBadge = async (id: string, badgeData: BadgeUpdateData): Promise<IBadge> => {
  const response = await axiosInstance.put(`/api/badges/${id}`, badgeData);
  return response.data;
};

// Delete a badge (soft delete)
export const deleteBadge = async (id: string): Promise<{ message: string }> => {
  const response = await axiosInstance.delete(`/api/badges/${id}`);
  return response.data;
};

// Reorder badges
export const reorderBadges = async (badgeIds: string[]): Promise<{ message: string }> => {
  const response = await axiosInstance.post('/api/badges/reorder', { badgeIds });
  return response.data;
};

// Asset badge management functions

// Add badges to an asset
export const addBadgesToAsset = async (assetId: string, badgeIds: string[]): Promise<{ message: string; activeBadges: IBadge[] }> => {
  const response = await axiosInstance.post(`/api/assets/${assetId}/badges`, { badgeIds });
  return response.data;
};

// Remove badges from an asset
export const removeBadgesFromAsset = async (assetId: string, badgeIds: string[]): Promise<{ message: string; activeBadges: IBadge[] }> => {
  const response = await axiosInstance.delete(`/api/assets/${assetId}/badges`, { data: { badgeIds } });
  return response.data;
};

// Set badges for an asset (replace all)
export const setBadgesForAsset = async (assetId: string, badgeIds: string[]): Promise<{ message: string; activeBadges: IBadge[] }> => {
  const response = await axiosInstance.put(`/api/assets/${assetId}/badges`, { badgeIds });
  return response.data;
}; 